// Initialize an API client object
const api = new Gadget();

const fetchTransactions = async (customerId) => {
  try {
    const variables = {
      customerId: customerId, // This uses the global customerId variable
    };
    const result = await api.getTransactions(variables);
    return result;
  } catch (error) {
    console.error("Error fetching transactions from external system:", error);
    throw error;
  }
};

const fetchTransactionData = async (customerId) => {
  if (!customerId) {
    return { transactionsResult: null, lineItemsResult: null };
  }

  try {
    const variables = {
      customerId: customerId,
    };
    const result = await api.getOipTransactions(variables);
    
    if (!result) {
      console.log("No transaction data found for customer");
      return { transactionsResult: null, lineItemsResult: null };
    }

    return {
      transactionsResult: result.transactionsResult || null,
      lineItemsResult: result.lineItemsResult || null
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    console.error("Error details:", error.message, error.stack);
    return { transactionsResult: null, lineItemsResult: null };
  }
};

const fetchBonusPoints = async (customerId, mobilePhone) => {
  try {
    const customerGID = `gid://shopify/Customer/${customerId}`;
    const variables = {
      customerGID: customerGID,
      mobilePhone: mobilePhone ? mobilePhone : undefined
    };

    const result = await api.getCustomerv4(variables);
    return result;
  } catch (error) {
    console.error("Error fetching bonus points:", error);
  }
};

const fetchCustomerData = async (customerId) => {
  try {
    const variables = {
      customerId: customerId, // This uses the global customerId variable
    };
    const result = await api.getCustomer(variables);
    return result.member;
    
  } catch (error) {
    console.error("Error fetching customer data:", error);
  }
};

const checkVoyadoMember = async (customerData) => {
  try {
    const variables = {
      mobilePhone: customerData.mobilePhone,
      email: customerData.email,
      firstName: customerData.firstName,
      lastName: customerData.lastName,
      birthDate: customerData.birthDate
    };
    const result = await api.memberCheck(variables);
    return result;
  } catch (error) {
    console.error("Error checking Voyado member:", error);
  }
};

const checkShopifyMember = async (mobilePhone, email) => {
  try {
    const variables = {
      mobilePhone: mobilePhone,
      email: email
    };
    const result = await api.shopifyCheck(variables);
    return result;
  } catch (error) {
    console.error("Error checking Shopify member:", error);
  }
};

const updateFavorites = async (selectedStores) => {
  try {
    const variables = {
      customerId: customerId,
      favoriteStores: selectedStores.toString()
    }
    const result = await api.updateFavouriteStores(variables);
    return result;
  }
  catch (error) {
    console.error("Error updating favorites:", error);
  }
};

const memberSignup = async (variables) => {
  try {
    const result = await api.memberSignup(variables);
    return result;
  }
  catch (error) {
    console.error("Error fetching customer data:", error);
  }
};

const memberCancel = async () => {
  try {
    const variables = {
      customerId: customerId, // This uses the global customerId variable
    };
    const result = await api.memberCancel(variables);
    return result;
  }
  catch (error) {
    console.error("Error fetching customer data:", error);
  }
};

const memberRegister = async (customerData) => {
  try {
    let variables = {
      customerId: customerId,
      email: customerData.email,
      memberId: customerData.memberId,
      firstName: customerData.firstName,
      lastName: customerData.lastName,
      acceptEmail: true,
      acceptTerms: true,
      acceptSms: true,
      acceptMarketing: customerData.acceptMarketing,
      mobilePhone: customerData.mobilePhone,
    };
    if (customerData.birthDate) {
      variables.birthDate = customerData.birthDate;
    }
    const result = await api.memberRegister(variables);
    return result;
  } catch (error) {
    console.error("Error registering member:", error);
  }
};

const storeRegister = async (customerData) => {
  try {
    let variables = {
      email: customerData.email,
      memberId: customerData.memberId,
      firstName: customerData.firstName,
      lastName: customerData.lastName,
      acceptMarketing: customerData.acceptMarketing,
      mobilePhone: customerData.mobilePhone,
    };
    if (customerData.birthDate) {
      variables.birthDate = customerData.birthDate;
    }
    const result = await api.storeRegister(variables);
    return result;
  } catch (error) {
    console.error("Error registering member:", error);
  }
};

const updateCustomerData = async (customerData) => {
  try {

    const variables = {
      customerId: customerId, // This uses the global customerId variable
    };
   
    const customerVariables = {
      customerId: customerId,
      firstName: customerData.firstName,
      lastName: customerData.lastName,
      email: customerData.email,
      mobilePhone: customerData.mobilePhone,
      acceptEmail: customerData.acceptEmail,
      acceptSms: customerData.acceptSms,
      acceptMarketing: customerData.acceptMarketing,
      birthDate: customerData.birthDate,
      favoriteStores: customerData.favoriteStores,
      //phone: "customerData.phone",
      // Add other fields as needed
    };
    if (customerData.birthDate) {
      customerVariables.birthDate = customerData.birthDate;
    }

    const result = await api.updateCustomer(customerVariables);
    return result;
    
  } catch (error) {
    console.error("Error updating customer data:", error);
  }
};


// Function to update the UI with the fetched data
function updateUI(customerData, transactions, lineItems) {
  localStorage.setItem('oipTransactions', JSON.stringify(transactions));
}

// Clear the flag when the customer logs out
const onCustomerLogout = () => {
  localStorage.removeItem('customerDataFetched');
};

document.addEventListener('DOMContentLoaded', () => {


  // Add logout event listener
  const logoutLink = document.querySelector('a[href="/account/logout"]');
  if (logoutLink) {
    logoutLink.addEventListener('click', (event) => {
      event.preventDefault();
      onCustomerLogout();
      // Redirect to logout URL after handling the logout
      window.location.href = logoutLink.href;
    });
  }
});